// extracted by mini-css-extract-plugin
export default {"header-title":"user-members-header__header-title--AQzHY","headerTitle":"user-members-header__header-title--AQzHY"};